import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { EMPTY } from 'rxjs';
import { ServiceLocator } from '../services/infrastructure/service-locator.service';
import { EShopState } from '../services/INTEGRA_Shop_Client';
import { ENVIRONMENT } from '../environment/environment';
import { IAuthService, IAuthServiceToken } from '../services/infrastructure/authentication/auth-service.interface';
import { IUserService, IUserServiceToken } from '../services/data/user/user-service.interface';
import { IIdpApiService, IIdpApiServiceToken } from '../services/api/idp/idp-api-service.interface';
import { IConfigurationServiceToken } from '../services/infrastructure/configuration/configuration-service.interface';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const httpShopStateInterceptor: HttpInterceptorFn = (req, next) => {
  let authService: IAuthService = inject(IAuthServiceToken);
  let userService: IUserService = inject(IUserServiceToken);
  let idpApiService: IIdpApiService | null = inject(IIdpApiServiceToken, { optional: true });
  let configuration = ServiceLocator.injector.get(IConfigurationServiceToken);

  let maintenanceAllowedRequestList: string[] | undefined = ENVIRONMENT.stateList?.find(s => s.shopState.includes(EShopState.Maintenance))?.allowedRequests;
  let offlineAllowedRequestList: string[] | undefined = ENVIRONMENT.stateList?.find(s => s.shopState.includes(EShopState.Offline))?.allowedRequests;

  let shopState = configuration.shopStateGetOrUndefined();

  let urlWithParams = req.urlWithParams;

  switch (shopState) {

    case undefined:
      return next(req);

    case EShopState.Online:
      return next(req);

    case EShopState.Maintenance:
      logoutCheck(authService, userService, idpApiService);

      if (maintenanceAllowedRequestList?.some(r => urlWithParams.includes(r))) {
        return next(req);
      }
      return EMPTY;

    case EShopState.Offline:
      logoutCheck(authService, userService, idpApiService);

      if (offlineAllowedRequestList?.some(r => urlWithParams.includes(r))) {
        return next(req);
      }
      return EMPTY;

    default:
      break;
  }

  return next(req);
}

function logoutCheck(authService: IAuthService, userService: IUserService, idpApiService: IIdpApiService | null) {
  idpApiService?.logout();

  authService.authenticatedGet().subscribe(
    (isAuthenticated) => {
      if (isAuthenticated) {
        userService.userLogout().subscribe({
          next: () => {
            authService.accessJWTClear();
          }
        });
      }
    }
  );
}
